module.exports = __webpack_public_path__ + "static/media/rebateIcon.3d5926fb.svg";